<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
<!--                     <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <b-table class="mt-2 mb-2" borderless small bordered responsive thead-tr-class="table-success" :items="tableItems" :fields="tableFields"></b-table>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <DownloadExcelTemplate :code="'translations_excel_import'"/>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>

                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component


// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import JobService from "@/services/JobService";
import excelImportTemplate from "@/services/ExcelImportTemplate";
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";

export default {
    components: {
        DownloadExcelTemplate,

        ValidationProvider,
        ValidationObserver
    }
    ,
    data() {
        return {
            defineForm: {
                semester_id: null,
                file: null
            },
            loading: false,
            tableFields: [
                {
                    key: 'student_program_id',
                    label: this.$t('sample_template_excel'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'key',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'tr',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'en',
                    label: '',
                    tdClass: 'border text-center',
                },
            ],
            tableItems: [
                {
                    student_program_id: this.$t('group'),
                    key:'key',
                    tr:'TR',
                    en:'EN'
                },
            ]
        }
    }
    ,
    methods: {
        async sendForm() {
            const isValid = await this.$refs.updateForm.validate();
            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])
                return JobService.bulkTranslationImport(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.defineForm.file=null
                        // this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                        this.$emit('successProcess',true)
                    })
                    .catch(e => {
                        this.showErrors(e,this.$refs.updateForm)
                    })
            }
        },
    }
}
</script>
